import { queryClient } from '../index';

// Clear all React Query cache when user logs out
export const clearQueryCache = () => {
  try {
    // Clear all queries from the cache
    queryClient.clear();

    // Also remove specific query patterns to be extra sure
    queryClient.removeQueries({ queryKey: ['calendarEvents'] });
    queryClient.removeQueries({ queryKey: ['allEventTypes'] });
    queryClient.removeQueries({ queryKey: ['freeDays'] });
    queryClient.removeQueries({ queryKey: ['freeDaysForParticularRate'] });

    console.log('React Query cache cleared successfully');
  } catch (error) {
    console.error('Error clearing React Query cache:', error);
  }
};

// Clear specific query patterns
export const clearUserSpecificQueries = () => {
  try {
    // Clear calendar-related queries
    queryClient.removeQueries({ queryKey: ['calendarEvents'] });
    queryClient.removeQueries({ queryKey: ['allEventTypes'] });

    // Clear other user-specific queries as needed
    queryClient.removeQueries({ queryKey: ['freeDays'] });
    queryClient.removeQueries({ queryKey: ['freeDaysForParticularRate'] });

    console.log('User-specific queries cleared successfully');
  } catch (error) {
    console.error('Error clearing user-specific queries:', error);
  }
};
